import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { KakaoUser } from '../services/kakaoAuth';

export interface User {
  id: number;
  email?: string;
  nickname?: string;
  profileImage?: string;
  phone?: string;
  kakaoId?: number;
}

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  accessToken: string | null;

  // Actions
  login: (user: User, accessToken: string) => void;
  logout: () => void;
  updateUser: (user: Partial<User>) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      accessToken: null,

      login: (user: User, accessToken: string) => {
        set({
          user,
          isAuthenticated: true,
          accessToken,
        });
      },

      logout: () => {
        set({
          user: null,
          isAuthenticated: false,
          accessToken: null,
        });
        // Clear tokens from localStorage
        localStorage.removeItem('kakao_access_token');
        localStorage.removeItem('kakao_refresh_token');
        localStorage.removeItem('kakao_token_expires_at');
      },

      updateUser: (updatedUser: Partial<User>) => {
        set((state) => ({
          user: state.user ? { ...state.user, ...updatedUser } : null,
        }));
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);

/**
 * Kakao 사용자 정보를 앱 User 형식으로 변환
 */
export const mapKakaoUserToUser = (kakaoUser: KakaoUser): User => {
  return {
    id: kakaoUser.id,
    kakaoId: kakaoUser.id,
    email: kakaoUser.kakao_account.email,
    nickname: kakaoUser.kakao_account.profile?.nickname,
    profileImage: kakaoUser.kakao_account.profile?.profile_image_url,
  };
};
